import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../constants'

import { ModalContext } from '../../provider/ModalProvider'

import { useNavigate } from '../../hooks/useNavigate'

import { Button } from '../../components/button'
import { Modal } from '../../components/modal'
import { Text } from '../../components/text'

import { ReactComponent as ExclamationIcon } from '../../assets/gui/exclamation_60.svg'

export function IsSignInModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const login = () => {
    close()
    navigate('/signIn')
  }

  const close = () => {
    closeModal(MODALS_ID.IS_SIGNIN)
  }

  return (
    <Modal id={MODALS_ID.IS_SIGNIN} onClose={close}>
      <Content>
        <ExclamationIcon />
        <Text size={16} weight={500} lineHeight={24}>
          로그인 후 이용이 가능해요.
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={login}>
          로그인하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`
